import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-component p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-input-filled p-col-12" }
const _hoisted_3 = { class: "p-field p-col-12 p-mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_DocumentSearchMask = _resolveComponent("DocumentSearchMask")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.DocumentClass')), 1),
      _createVNode(_component_Dropdown, {
        id: "active",
        modelValue: _ctx.selectedDocumentClass,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedDocumentClass) = $event)),
        options: _ctx.documentClasses,
        optionValue: "id",
        optionLabel: _ctx.getTranslatedDescription,
        placeholder: _ctx.$t('Squeeze.DocumentClasses.PleaseSelect'),
        filter: true,
        autoFilterFocus: true,
        showClear: true,
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectDocumentClass($event))),
        onShow: _ctx.showDropdownOverlay
      }, null, 8, ["modelValue", "options", "optionLabel", "placeholder", "onShow"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_DocumentSearchMask, {
        onSubmit: _ctx.submit,
        "search-mask": _ctx.searchMask
      }, null, 8, ["onSubmit", "search-mask"])
    ])
  ]))
}